module.exports = __webpack_public_path__ + "static/assets/0c412d0f480f5d3a6af2148ab76afb8e.svg";